import {order_statuses} from '../../helpers/status_helper.js'

export default{
    state: {
        all_orders: [],
        status_rules: []
    },
    mutations:{
        setOrders(state, orders){
            state.all_orders = orders
        },
        setStatusRules(state, status_rules){
            state.status_rules = status_rules
        },
        insertOrder(state, order){
            state.all_orders = [order, ...state.all_orders]
        },
        updateOrder(state, order){
            state.all_orders = state.all_orders.map( item => item.id == order.id ? order : item)
        },
    },
    actions:{
        async getOrders({ dispatch, commit }){
            await commit('setOrders', await dispatch('apiQuery', {method: '/order/ui'}))
        },
        async getStatusRules({dispatch, commit}){
            await commit('setStatusRules', await dispatch('apiQuery', {method: '/order/status_rules'}))
        },
        async changeStatus({ dispatch }, body){
            return await dispatch('apiQuery', {method: '/order/status', body})
        },
        async confirmOrder({dispatch}, body){
            await dispatch('apiQuery', {method: '/order/apply', body})
        },
        async resyncOrder({dispatch}, body){
            await dispatch('apiQuery', {method: '/order/resync', body})
        },
        async getOrderContentByID({dispatch}, order_id){
            return await dispatch('apiQuery', {method: `/order/ui/${order_id}`})
        }
    },
    getters:{
        orders(state){
            return state.all_orders
        }, 
        status_rule_obj(state){
            return state.status_rules
        },
        ordersByStatus(state){
            return state.all_orders.reduce((hash, item)=>{
                if(!hash[item.status]){
                    hash[item.status] = []
                }
                hash[item.status].push(item)
                return hash
            }, {})
        },
        orderById(state){
            return (id) => {
                return state.all_orders?.find(item => item.id == id)
            }
        },
        orderByIdAndStatus(state, getters){
            return (id, status) => {
                return getters.ordersByStatus[status]?.find(item => item.id == id)
            }
        },
        status_dict(state){
            Object.keys(order_statuses).forEach((key)=>{
                if(key in state.status_rules){
                    order_statuses[key]['rule'] = Array.isArray(state.status_rules[key]) ? [...state.status_rules[key]] : [state.status_rules[key]]  
                }
            })

            return order_statuses
        }
    }
}